export default __webpack_public_path__ + "static/media/Android.b998c870.png";